export const COMPLETE_GTM_EVENT = 'Complete';
export const SIGN_UP_COMPLETE_EVENT = 'SignUpComplete';
export const LEAD_EVENT = 'Lead';
export const PAGE_VIEW_EVENT = 'PageView';
export const VIEW_REACTIVATION_EVENT = 'ViewReactivation';
export const REACTIVATION_EVENT = 'ReactivateAccount';
export const GENERIC_AHOY_EVENT = 'Event';
export const POPULATE_DATA_LAYER = 'PopulateDataLayer';
export const ADD_TO_CART_EVENT = 'AddToCart';
export const BEGIN_CHECKOUT_EVENT = 'BeginCheckout';
